import { cloneDeep } from "lodash";
import { IFormBuilderForm } from "../../editor/model/formBuilderForm";
import { TFormBuilderItem } from "../../editor/model/item/formBuilderItem";
import { IFormBuilderRow } from "../../editor/model/formBuilderRow";
import { IFormBuilderItemOption } from "../../editor/model/item/formBuilderItemOption";

function sanitizeForm(form: IFormBuilderForm): IFormBuilderForm {
  const duplicatedForm = cloneDeep(form);

  duplicatedForm.id = null;
  duplicatedForm.key = crypto.randomUUID();
  duplicatedForm.updatedAt = null;
  duplicatedForm.archivedAt = null;

  duplicatedForm.children.forEach(sanitizeRow);

  return duplicatedForm;
}

function sanitizeRow(row: IFormBuilderRow): IFormBuilderRow {
  row.id = null;
  row.key = crypto.randomUUID();
  row.data.formId = null;
  row.children.forEach(sanitizeItem);

  return row;
}

function sanitizeItem(item: TFormBuilderItem): TFormBuilderItem {
  item.id = null;
  item.key = crypto.randomUUID();
  item.data.formRowId = null;

  if (item.data.type === "select") {
    item.data.settings.options.forEach(sanitizeItemOption);
  }

  return item;
}

function sanitizeItemOption(itemOption: IFormBuilderItemOption): IFormBuilderItemOption {
  itemOption.id = null;
  itemOption.formItemId = null;
  
  return itemOption;
}

export function formBuilderSanitizeForm(form: IFormBuilderForm): IFormBuilderForm {
  return sanitizeForm(form);
}